import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const BreadCrumbs = ({ breadcrumbs }) => (
    <ul className="breadcrumbs">

        {breadcrumbs.map((breadcrumb) => (
            <li key={breadcrumb.title}>
                <a href={breadcrumb.url}> {breadcrumb.title} </a>
            </li>
        ))}
    </ul>
);

const BreadCrumbType = PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
});

BreadCrumbs.propTypes = {
    breadcrumbs: PropTypes.arrayOf(BreadCrumbType)
};

export default BreadCrumbs;
